import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/card/index',
    method: 'get',
    params
  })
}

export function getCardDetail(params) {
  return request({
    url: '/card/detail',
    method: 'get',
    params
  })
}

export function assignable(data) {
  return request({
    url: '/card/assignable',
    method: 'post',
    data
  })
}

export function cardAssign(data) {
  return request({
    url: '/card/assign',
    method: 'post',
    data
  })
}

export function backable(data) {
  return request({
    url: '/card/backable',
    method: 'post',
    data
  })
}

export function cardBack(data) {
  return request({
    url: '/card/back',
    method: 'post',
    data
  })
}

export function switchFlowOn(params) {
  return request({
    url: '/card/switch_flow_on',
    method: 'get',
    params
  })
}

export function statusSync(params) {
  return request({
    url: '/card/status_sync',
    method: 'get',
    params
  })
}

export function getStatistics(params) {
  return request({
    url: '/card/statistics',
    method: 'get',
    params
  })
}

export function removeCustomer(params) {
  return request({
    url: '/card/remove_customer',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/card.js